// Message formatting — ported verbatim from ui.js formatMessage.
// Escapes HTML, linkifies URLs, then applies a small markdown subset
// (code blocks, inline code, bold, italic, paragraphs, line breaks).
// Output is an HTML string rendered via dangerouslySetInnerHTML — safe because
// all user/content text is HTML-escaped before any tags are introduced.

export function formatMessage(content: string): string {
  let formatted = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // Linkify URLs (after escaping, before markdown).
  formatted = formatted.replace(/(https?:\/\/[^\s<\]}'"()]+)/g, (match, url: string) => {
    const cleaned = url.replace(/[.,;:!?)\]}>]+$/, '')
    return `<a href="${cleaned}" target="_blank" rel="noopener noreferrer">${cleaned}</a>`
  })

  formatted = formatted.replace(/```(\w*)\n?([\s\S]*?)```/g, (match, lang: string, code: string) => {
    return `<pre><code class="language-${lang}">${code.trim()}</code></pre>`
  })

  formatted = formatted.replace(/`([^`]+)`/g, '<code>$1</code>')
  formatted = formatted.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  formatted = formatted.replace(/\*([^*]+)\*/g, '<em>$1</em>')
  formatted = formatted
    .split('\n\n')
    .map((p) => `<p>${p}</p>`)
    .join('')
  formatted = formatted.replace(/\n/g, '<br>')

  return formatted
}

// Marker the backend embeds in month-end insight messages.
export const CTA_SESSION_MARKER = '[CTA_SESSION]'
